import { useEffect } from "react";

const DEFAULT_TITLE = "Golf Motion Lab — Valoración integral del golfista";
const DEFAULT_DESCRIPTION =
  "Conectamos cuerpo y swing para mejorar tu juego. Valoramos movilidad, fuerza, rendimiento y control motor con tecnología VALD, TrackMan y OnForm. Informe integral con sistema de puntuación 0-100.";

interface SeoProps {
  title: string;
  description?: string;
  noIndex?: boolean;
}

export function useSeo({ title, description, noIndex = false }: SeoProps) {
  useEffect(() => {
    document.title = title;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && description) {
      metaDesc.setAttribute("content", description);
    }

    let robotsTag = document.querySelector('meta[name="robots"]');
    if (noIndex) {
      if (!robotsTag) {
        robotsTag = document.createElement("meta");
        robotsTag.setAttribute("name", "robots");
        document.head.appendChild(robotsTag);
      }
      robotsTag.setAttribute("content", "noindex, follow");
    }

    return () => {
      document.title = DEFAULT_TITLE;
      if (metaDesc) metaDesc.setAttribute("content", DEFAULT_DESCRIPTION);
      if (noIndex && robotsTag) robotsTag.removeAttribute("content");
    };
  }, [title, description, noIndex]);
}
